(function () {

  function waitForElm(selector) {
    return new Promise((resolve) => {
      const found = document.querySelector(selector);
      if (found) return resolve(found);

      const observer = new MutationObserver(() => {
        const el = document.querySelector(selector);
        if (el) {
          resolve(el);
          observer.disconnect();
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  function getLocale() {
    return document.documentElement.getAttribute("lang") || navigator.language || "en-CA";
  }

  function getCurrencyCode() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : "CAD";
  }

  function formatMoney(amountNumber) {
    const n = Number(amountNumber);
    if (!Number.isFinite(n)) return "";
    try {
      return n.toLocaleString(getLocale(), { style: "currency", currency: getCurrencyCode() });
    } catch (e) {
      return (getCurrencyCode() + " " + n.toFixed(2));
    }
  }

  function getElement(sel) {
    return document.querySelector(sel);
  }

  function getActiveRechargeOption() {
    return document.querySelector(".rc-template__button-group .rc-radio.rc-option--active input");
  }

  function isSubsaveSelected() {
    return getActiveRechargeOption()?.value === "subsave";
  }

  function postJson(url, data, callbacks = {}) {
    const body = new URLSearchParams();

    Object.keys(data || {}).forEach(function (key) {
      body.append(key, data[key]);
    });

    if (typeof callbacks.beforeSend === "function") {
      callbacks.beforeSend();
    }

    return fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: body.toString(),
    })
      .then(function (response) {
        if (!response.ok) throw response;
        return response.json();
      })
      .then(function (payload) {
        if (typeof callbacks.success === "function") {
          callbacks.success(payload);
        }
        return payload;
      })
      .catch(function (error) {
        if (typeof callbacks.error === "function") {
          callbacks.error(error);
        }
        throw error;
      });
  }

  function getJson(url, callback) {
    return fetch(url, {
      headers: {
        Accept: "application/json",
      },
    })
      .then(function (response) {
        if (!response.ok) throw response;
        return response.json();
      })
      .then(function (payload) {
        if (typeof callback === "function") {
          callback(payload);
        }
        return payload;
      });
  }

  function setCaseSelection(caseElement, shouldActivate, onChange) {
    const caseSelection = caseElement?.closest(".case_selection");
    const caseBox = caseElement?.closest(".casbox");
    const button = caseBox?.querySelector(".btn-box");

    if (!caseSelection || !caseBox || !button) return;

    caseSelection.querySelector(".single_case.active")?.classList.remove("active");
    caseSelection.querySelector(".btn-box.active")?.classList.remove("active");

    if (shouldActivate) {
      caseElement.classList.add("active");
      button.classList.add("active");
    }

    if (typeof onChange === "function") {
      onChange();
    }
  }

  waitForElm(".rc_widget .rc-selling-plans select.rc_widget__option__plans__dropdown").then(() => {
    setTimeout(function () {
      document.querySelectorAll(".single_case").forEach(function (caseEl) {
        const priceTextEl = caseEl.querySelector(".single_case_txt p");
        if (!priceTextEl) return;

        const regex = /\$(\d+(\.\d+)?)/g;
        const matches = [...priceTextEl.innerHTML.matchAll(regex)];
        if (matches.length < 2) return;

        const originalPrice = parseFloat(matches[0][1]);
        const correctedPrice = (originalPrice * 0.6).toFixed(2);

        priceTextEl.innerHTML = priceTextEl.innerHTML.replace(matches[1][0], `$${correctedPrice}`);
        caseEl.setAttribute("data-price", correctedPrice);
      });

      const allRcOptions = document.querySelectorAll(
        ".rc-template__button-group .rc-radio.rc_widget__option input"
      );
      const activeButton = getElement(".rc-template__button-group .rc-radio.rc-option--active input");
      const cartButton = getElement(".shopify-product-form button[name='add']");
      if (!cartButton) return;

      const cartButtonText = cartButton.getAttribute("data-add-text") || cartButton.innerText || "Add to cart";
      const saveElement = document.createElement("span");
      saveElement.classList.add("savePrice");

      function changeButton(buttonText, saveAvailable) {
        if (!cartButton.hasAttribute("disabled")) {
          cartButton.innerText = buttonText;
        }

        if (saveAvailable) {
          const subTotalText = getElement(".rc-option__subsave span[data-price-subsave]")
            ?.innerText.replace("$", "");
          let subTotalPrice = Number(subTotalText);

          if (subTotalPrice) {
            const activeCaseValue = document.querySelector(".single_case.active")?.getAttribute("data-price");
            if (activeCaseValue) subTotalPrice = subTotalPrice + Number(activeCaseValue);
            saveElement.innerText = formatMoney(subTotalPrice);
          }
          cartButton.insertAdjacentElement("beforeend", saveElement);
        } else {
          cartButton.querySelector(".savePrice")?.remove();
        }
      }

      if (activeButton && activeButton.value === "subsave") {
        changeButton("Subscribe now", true);
      }

      if (allRcOptions.length > 0) {
        allRcOptions.forEach(function (e) {
          e.addEventListener("change", function () {
            if (this.value === "subsave") {
              changeButton("Subscribe now", true);
            } else {
              changeButton(cartButtonText, false);
            }
          });
        });
      }

      document.querySelectorAll(".btn-box").forEach(function (button) {
        button.addEventListener("click", function () {
          const caseElement = this.closest(".casbox")?.querySelector(".single_case");
          const isActive = this.classList.contains("active");
          setCaseSelection(caseElement, !isActive, function () {
            changeButton("Subscribe now", true);
          });
        });
      });

      const caseTrigger = document.querySelectorAll(".single_case");
      if (caseTrigger.length > 0) {
        caseTrigger.forEach(function (e) {
          e.addEventListener("click", function () {
            const isActive = this.classList.contains("active");
            setCaseSelection(this, !isActive, function () {
              changeButton("Subscribe now", true);
            });
          });
        });
      }

      const gift_products = document.querySelectorAll(".gift-imges .variantImage");
      if (gift_products.length > 0) {
        gift_products.forEach(function (e) {
          e.addEventListener("click", function () {
            this.closest(".gift-imges")?.querySelector(".variantImage.active")?.classList.remove("active");
            this.classList.add("active");
          });
        });
      }
    }, 1200);
  });

  if (sessionStorage.getItem("bundleToken") != null) {
    var token = sessionStorage.getItem("bundleToken");
    postJson("/cart/clear.js", { token: token }, {
      success: function () {
        sessionStorage.removeItem("bundleToken");
        document.dispatchEvent(new CustomEvent("cart:build"));
        document.querySelector("#cart-icon-bubble .cart-count-bubble")?.remove();
      },
    });
  }

  const giftBox = document.querySelector(".gift_compartment_box");
  if (giftBox) {
    waitForElm(".rc-widget .rc-radio-group__options input.rc-radio__input").then(() => {
      const radioTrigger = document.querySelectorAll(".rc-widget .rc-radio-group__options input.rc-radio__input");
      if (radioTrigger.length > 0) {
        function checkValue() {
          const selectedValue = document.querySelector(
            ".rc-widget .rc-radio-group__options input.rc-radio__input:checked"
          );
          const selectedInputValue = selectedValue ? selectedValue.value : "";
          if (selectedInputValue === "subsave") giftBox.classList.add("active");
          else giftBox.classList.remove("active");
        }
        checkValue();
        radioTrigger.forEach(function (e) {
          e.addEventListener("change", function () {
            checkValue();
          });
        });
      }
    });
  }

  document.addEventListener("ajaxProduct:added", function () {
    if (subscription_selected) {
      document.body.classList.add("bodyDisabled");
      setTimeout(function () {
        getJson("/cart.js", function (cart) {
          sessionStorage.setItem("bundleToken", cart.token);
          location.href = "/checkout";
        }).catch(function () {
          location.href = "/checkout";
        });
      }, 1000);
    } else {
      if (actionTrigger) actionTrigger.style.pointerEvents = "unset";
    }
  });

  let subscription_selected = false;
  const actionForm = document.querySelector("form.shopify-product-form");
  const actionTrigger = document.querySelector("form.shopify-product-form button[name='add']");

  if (actionTrigger && actionForm) {
    let counter = 0;

    function setCounter() {
      setTimeout(function () {
        counter = 0;
      }, 200);
    }

    actionTrigger.addEventListener("click", function (event) {
      const rcInput = document.querySelector(".rc-widget .rc-radio-group__options input.rc-radio__input");
      if (!rcInput) return;

      const selectedValue = document.querySelector(".rc-widget .rc-radio-group__options input.rc-radio__input:checked");
      const selectedInputValue = selectedValue ? selectedValue.value : "";

      if (selectedInputValue !== "subsave") return;

      if (counter !== 0) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      subscription_selected = true;

      function compartmentSend() {
        const activeCase = document.querySelector(".case_selection .single_case.active");
        if (activeCase) {
          const variantId = Number(activeCase.getAttribute("data-variant"));
          actionTrigger.style.pointerEvents = "none";

          let formData = { items: [{ id: variantId, quantity: 1 }] };

          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData),
          })
            .then(() => {
              actionTrigger.style.pointerEvents = "unset";
              counter = 1;

              try {
                actionForm.requestSubmit ? actionForm.requestSubmit() : actionForm.submit();
              } catch (e) {
                actionForm.submit();
              }

              setCounter();
              actionTrigger.style.pointerEvents = "none";
            })
            .catch((error) => {
              console.error("Error:", error);
              actionTrigger.style.pointerEvents = "unset";
              try {
                actionForm.requestSubmit ? actionForm.requestSubmit() : actionForm.submit();
              } catch (e) {
                actionForm.submit();
              }
              setCounter();
            });
        } else {
          counter = 1;
          try {
            actionForm.requestSubmit ? actionForm.requestSubmit() : actionForm.submit();
          } catch (e) {
            actionForm.submit();
          }
          setCounter();
        }
      }

      const giftContainer = document.querySelector(".sec_1_right_item3 .gift_container .variantImage.active");
      if (giftContainer) {
        postJson("/cart/add.js", {
            quantity: 1,
            id: Number(giftContainer.getAttribute("data-variant")),
          }, {
          success: function () {
            compartmentSend();
          },
          error: function () {
            compartmentSend();
          },
        });
      } else {
        compartmentSend();
      }
    });
  }
})();
